import { Component, Input, OnInit } from '@angular/core';
import packageJson from 'package.json';

import dayjs from 'dayjs';

import { LanguageEnum } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule, PrimeModule } from '@module';

import { DatePipe } from 'pn-core-code';

import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'shared-audit-field',
  standalone: true,
  imports: [DefaultModule, PrimeModule, DialogModule, DatePipe],
  template: `
    <span>{{!dateTime ? '-' : dateTime | libDate: 'dateTime'}}</span>
    <p>{{name ? name : '-'}}</p>
  `,
  styles: ``,

})
export class SharedAuditFieldComponent implements OnInit {

  @Input() dateTime: any;
  @Input() name: any;

  visible: boolean = false;

  constructor(
    private translateService: TranslateService
  ) {

  }

  ngOnInit(): void {
  }

}
